import { NgModule } from '@angular/core';
import { DialogClosedFocusDirective } from './dialog-closed-focus.directive';

@NgModule({
  declarations: [DialogClosedFocusDirective],
  exports: [DialogClosedFocusDirective],
})
export class DialogClosedFocusModule {}
